import Const from 'constants';
import {combineReducers} from 'redux';
import {getDefaultExposure} from 'helpers/player-helper';

const defaultState = {
    data: {
        1: {},
        2: {},
    },
    has(groupNumber, team) {
        return this.data[groupNumber].hasOwnProperty(team);
    },
    getValue(groupNumber, team) {
        if (this.has(groupNumber, team)) {
            return this.data[groupNumber][team];
        }
        return getDefaultExposure('max');
    },
    all() {
        return cp(this.data);
    },
};

export function exposureMax(state = defaultState, action) {
    if (action.type === Const.SET_EXPOSURE_MAX_OF_TEAM_STACKS) {
        const data = cp(state.data);
        data[action.groupNumber] = {
            ...data[action.groupNumber],
            [action.teamName]: action.exposureMaxPercent,
        };

        state = {...state, data};
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {...defaultState};
    }

    return state;
}

const reducers = {
    exposureMax,
};

export default combineReducers(reducers);
